import React, { useEffect, useState } from "react";
import "../QuizHub/QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { faArrowRight, faInfoCircle } from '@fortawesome/free-solid-svg-fields';
import bc from "../../images/book-cover.svg";
import com from "../../images/compass-icon.svg";
import sh from "../../images/shield.svg";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import Subscriptions from "../Subscriptions/Subscriptions";

function HubListingPage({slug,token,onsignup,onLoginChange,userdetail}) {

    const [loading, setLoading] = useState(true);

    const [hublist, sethublist] = useState([]);

    const [error, setError] = useState("");

    const [ShowModal, setShowModal] = useState(false);

    const subS = true;

    const [subscription, setSubscription] = useState(null);

    const LoginShow = () => {

        window.scrollTo({ top: 0, behavior: 'smooth' });
        onsignup(true); 
    };

    useEffect(() => {

        fetchQuiz();

    }, []);

    const fetchQuiz = async () => {

        try {

            setLoading(true);

            const response = await axios.get(

                `${END_URL}/hub_list/${slug}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.success) {

                sethublist(response.data.hub_list || []);

            } else {

                setError("Failed to load ebooks");
            }

        } catch (error) {

            console.log(error);

            setError("Something went wrong");

        } finally {

            setLoading(false);
        }
    };


    const handleSub = async (subJson) => {
        try {
          let subIds = [];
    
          if (typeof subJson === "string") {
            try {

              subIds = JSON.parse(subJson);

            } catch (e) {

              console.error("Invalid JSON string for subIds:", e);
              return;
            }
          } else if (Array.isArray(subJson)) {
            subIds = subJson;
          }
    
          setShowModal(true);
    
          const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
    
          setSubscription(res.data);
    
          localStorage.removeItem("pendingSubIds");
        } catch (err) {
          console.error("Error loading subscriptions:", err);
        }
    };

    if (loading) {  

        return (
            <div className="loadingDiv">
                <img src={ff} alt="Loading..." />
            </div>
        );
    }

  return (
    <>

    <div className="quizhub-cont hub-listing-detail">
      <div className="ques-main quizhub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">

              <div className="ques-top" style={{'--bg-image': `url(${IMG_URL}/d0/${hublist?.hub_banner_image})` }} >

                <div className="ques-top-title" dangerouslySetInnerHTML={{__html:hublist?.hub_banner_content}} />
            
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="container">

        <div className="row quizhub-book-cards-row">

          {hublist?.cards?.map((item, index) => {

            return (

                  item?.hub_topic_image && item?.hub_topic_image && (

                    <div className="col-md-4">

                      <div className="quiz-box">

                        <div className="quiz-imgDiv">

                          <img src={`${IMG_URL}/d0/${item?.hub_topic_image}`} alt="" />

                        </div>

                        {item?.main_topic == 1 && (

                          <span className="quiz-top">MAIN QUIZ</span>

                        )}

                        <div className="quizhub-content">

                          <h6>{item?.main_topic_label}</h6>
                          
                          <div dangerouslySetInnerHTML={{__html:item?.hub_topic_content}}/>
                          
                          <div className="quizhub-btn">

                            <a href={`${item?.quizlist?.hub_topic_button_link_1}`} class="new-commom-btn quizhub-take">

                                <span>{item?.hub_topic_button_1}</span>

                                <span class="righ-arr">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                            </a>

                            <a href={`${item?.hub_topic_button_2}`} class="new-commom-btn quiz-about">

                              <span>{item?.hub_topic_button_link_2}</span>

                              <span class="righ-arr">
                                <FontAwesomeIcon icon={faInfoCircle} />
                              </span>
                            </a>
                          </div>

                        </div>
                      </div>
                    </div>

                  )

                );
          })}

        </div>

        <div className="row ">
          <div className="adapter-cta-div adapter-cta-div-in-ebook">
            <div className="adapt-cta-img">
              <div>
                <span>
                  <img src={`${IMG_URL}/d0/${hublist?.hub_footer_image}`} alt="" />
                </span>
              </div>
            </div>

            <div className="adapt-cta-text" dangerouslySetInnerHTML={{__html:hublist?.hub_footer_content}}/>
        
            <div className="adapt-cta-btn">

              {hublist?.hub_footer_button && hublist?.hub_footer_button_link && (

                <a href={`${hublist?.hub_footer_button_link}`} class="new-commom-btn adapter-btn">

                  <span>{hublist?.hub_footer_button}</span>

                  <span class="righ-arr">

                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>

              )}

            </div>
          </div>
        </div>
      </div>

    </div>


    {ShowModal && (
          <div
            className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
              subscription?.data?.length == 1 ? "single-subscription" : ""
            }`}
          >
            <div className="newdashpop-inner">
              <div className="newdashpop-container">
                <button
                  className="newdashpop-close"
                  onClick={() => setShowModal(false)}
                >
                  &times;
                </button>

                <div className="conent-pop">
                  <Subscriptions
                    subs={subS}
                    userdetail={userdetail}
                    force_to_disable={false}
                    Subcription={subscription}
                    onLoginChange={onLoginChange}
                    free_popup={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
}

export default HubListingPage;
